import { Flex } from '@cognite/cogs.js-v10';
import { useSchedulesDataGridStates } from '@infield/features/checklist/checklist-scheduler/hooks/use-schedules-data-grid-states';
import { useSchedulesPage } from '@infield/features/checklist/checklist-scheduler/hooks/use-schedules-page';
import { useSchedulesTableSelectedDateFilter } from '@infield/features/checklist/checklist-scheduler/hooks/use-schedules-table-selected-date-filter';
import { LoadingSchedulesPlaceholder } from '@infield/features/checklist/checklist-scheduler/loading-schedules-placeholder/loading-schedules-placeholder';
import { SchedulesDataGrid } from '@infield/features/checklist/checklist-scheduler/schedules-data-grid/schedules-data-grid';
import { SchedulesProgressHeader } from '@infield/features/checklist/checklist-scheduler/schedules-progress-header';
import { SchedulesWeekPicker } from '@infield/features/checklist/checklist-scheduler/schedules-week-picker/schedules-week-picker';
import { LOCIZE_NAMESPACES, useTranslation } from '@infield/features/i18n';
import dayjs from 'dayjs';

import * as S from './elements';

export const SchedulesPage = ({ currentDate = new Date() }) => {
  const { t } = useTranslation(LOCIZE_NAMESPACES.checklist);

  const { checklists, isLoadingChecklists, createChecklistsFromToolbar } =
    useSchedulesPage();
  const { selectedDateFilter, setSelectedDateFilter } =
    useSchedulesTableSelectedDateFilter();
  const {
    schedulesDataGridSelectedRows,
    setSchedulesDataGridSelectedRows,
    checklistCreationProgressPercent,
  } = useSchedulesDataGridStates();

  const endOfToday = dayjs(currentDate).endOf('day');

  const loadingText = t(
    'LOADING_SCHEDULES_TEXT',
    'Loading schedules, please wait...'
  );

  return (
    <Flex direction="column" fullHeight>
      <SchedulesProgressHeader
        title={t(
          'SCHEDULES_PAGE_PROGRESS_BAR_TITLE',
          'You can continue working, but avoid reloading pages'
        )}
        subtitle={t(
          'SCHEDULES_PAGE_PROGRESS_BAR_DESCRIPTION',
          'Moving to Ready...'
        )}
        progressPercent={checklistCreationProgressPercent}
      />
      <S.SchedulesPageHeaderContainer>
        <SchedulesWeekPicker
          startDate={selectedDateFilter[0]}
          setDateRange={setSelectedDateFilter}
          endDate={selectedDateFilter[1]}
          today={endOfToday}
        />
      </S.SchedulesPageHeaderContainer>
      {isLoadingChecklists ? (
        <LoadingSchedulesPlaceholder loadingText={loadingText} />
      ) : (
        <SchedulesDataGrid
          translationFunction={t}
          selectedRows={schedulesDataGridSelectedRows}
          setSelectedRows={setSchedulesDataGridSelectedRows}
          checklists={checklists}
          handleCreateClick={createChecklistsFromToolbar}
        />
      )}
    </Flex>
  );
};
